import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import styles from './thumb.css'

import ProgressiveImage from '../../progressive-image/progressive-image'
import Icon from '../../../core/patterns/icon/icon'
import Play from '../../../resources/svgs/play.svg'

export default class Thumb extends PureComponent {
  static propTypes = {
    video: PropTypes.object.isRequired,
    selected: PropTypes.bool,
    isFluid: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
  }

  handleClick = () => this.props.onClick(this.props.video)

  handleKeyPress = event => {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault()
      this.handleClick()
    }
  }

  render() {
    const { video, selected, isFluid } = this.props
    const imageClassName = selected
      ? `${styles['image__container']} ${styles['image__container--selected']}`
      : styles['image__container']

    const itemClassName = isFluid
      ? `${styles['item']} ${styles['item--fluid']}`
      : styles['item']

    return (
      <li
        className={itemClassName}
        role="button"
        tabIndex={0}
        onClick={this.handleClick}
        onKeyPress={this.handleKeyPress}
      >
        <div className={imageClassName}>
          <ProgressiveImage observeOnScroll src={video.thumbnail} alt="" />
          <span className={styles['play']}>
            <Icon className={styles['icon']} glyph={Play} />
          </span>
        </div>
        <span className={styles['description']}>{video.title}</span>
      </li>
    )
  }
}
